<div style="position: relative; padding: 20px;" >

  <div style="color: red; padding-bottom: 10px; padding-right: 10px; padding-left: 10px; width: 500px;" [hidden]="errorMessage === null || errorMessage === ''">{{errorMessage}}</div>

  <h2 mat-dialog-title>{{title}}</h2>

  <mat-dialog-content [formGroup]="form">

    <div style="height:10px;"></div>

    <pre>{{message}}</pre>

    <div style="height:10px;"></div>

  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onNoClick()">
      Ok
    </button>
  </mat-dialog-actions>

</div>
